<template>
  <ul class="list-style-none">
    <li v-for="item in categories" :key="item.id">
      <router-link :to="`/${$i18n.locale}/categorypage/${item.id}`">
        <i class="fas fa-chevron-right"></i>
        <span v-if="$i18n.locale === 'mn'">{{ item.title }}</span>
        <span v-if="$i18n.locale === 'en'">{{ item.title_en }}</span>
      </router-link>
    </li>
  </ul>
</template>
<script>
export default {
  data() {
    return {
      categories: []
    };
  },
  async mounted() {
    await this.axios
      .get("https://api.mncert.org/categories")
      .then(response => (this.categories = response.data));
  }
};
</script>
